import ReactDOM from "react-dom";
import * as THREE from "three";
import React, { Suspense, useRef, useState } from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import { Text } from "@react-three/drei";
import resourceInfo from "../resourceInfo.json";

export function Box({ config, setConfig, ...props }: any) {
  // This reference gives us direct access to the THREE.Mesh object
  const ref = React.useRef() as any;
  // Hold state for hovered and clicked events
  const [hovered, hover] = React.useState(false);
  const [clicked, click] = React.useState(false);
  // Subscribe this component to the render-loop, rotate the mesh every frame
  // useFrame((state, delta) => (ref.current.rotation.x += 0.01));
  // Return the view, these are regular Threejs elements expressed in JSX

  // const lineGeometry = new THREE.BufferGeometry().setFromPoints(points)
  const resourceId = props.resourceId.toString() as keyof typeof resourceInfo;

  // console.log(config.selectedResource, props.resourceId);
  // console.log(config.selectedResource && config.selectedResource === props.resourceId);

  const disableResource =
    config.selectedResource && !(config.selectedResource && config.selectedResource === props.resourceId);
  //
  return (
    <>
      <mesh
        {...props}
        ref={ref}
        // scale={hovered ? 1.01 : 1}
        onDoubleClick={(event) => {
          // click(!clicked);
          // console.log(event.intersections[0].object.name);
          setConfig({ ...config, selectedResource: event.intersections[0].object.name, selectedRegion: undefined });
        }}
        // onPointerOver={(event) => {
        //   setConfig({ ...config, intersectionHoverIdsCube: event.intersections.map((i) => i.object.name) });
        // }}
        // onPointerOut={(event) => {
        //   setConfig({
        //     ...config,
        //     intersectionHoverIdsCube: config.intersectionHoverIdsCube.filter((id: any) => {
        //       return id !== event.object.name;
        //     }),
        //   });
        // }}
        name={props.resourceId}
      >
        <boxGeometry args={props.size} />
        <meshStandardMaterial
          color={resourceInfo[resourceId].color}
          transparent
          opacity={disableResource ? config.disabledCubeOpacity / 1000 : 1}
          needsUpdate
        />
        {/* {!config.selectedResource || config.selectedResource === props.resourceId ? (
          //@ts-ignore
          
        ) : (
          <meshStandardMaterial
            //@ts-ignore
            color={resourceInfo[props.resourceId].color}
            transparent={true}
           
            needsUpdate={true}
          />
        )} */}
      </mesh>

      {/* {(config.intersectionHoverIdsCube[0] === props.resourceId ||
        (config.intersectionHoverIdsCube.length === 0 && config.selectedResource === props.resourceId)) && (
        <Suspense fallback={null}>
          <Text
            // position={[props.position[0] + props.resourceId < 6 ? -50 : 50, props.position[1], props.position[2]]}
            position={[0, 50, 0]}
            scale={[10, 10, 10]}
            color="black" // default
            // anchorX="center" // default
            anchorY="middle" // default
            fontSize={0.8}
            textAlign="center"
          >
            Resource {props.resourceId} {"\n"}
            {resourceInfo[resourceId].name}
          </Text>
        </Suspense>
      )} */}
    </>
  );
}
